/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.WATERFALL_ITEM.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {FetchRequest, UUID, WaterfallItem} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of waterfall_items
 * on the server.
 * @param transaction_id .The UUID of the transaction to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_waterfall_item(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_ITEM,
        method: HttpMethods.GET,
        query_parameters: {transaction_id: transaction_id},
    }
}

/**
 * Creates a FetchRequest object for updating a waterfall item on the server.
 * @returns A FetchRequest object for the PUT request.
 * @param waterfallItem Provides the data to be sent to the server for updating
 */
export function getRequest_update_waterfall_item(waterfallItem: WaterfallItem): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_ITEM,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: waterfallItem
    };
}

/**
 * Creates a FetchRequest object for deleting a waterfall item on the server.
 * @param waterfall_item_id The UUID of the waterfall item to delete.
 * @returns A FetchRequest object for the DELETE request.
 */
export function getRequest_delete_waterfall_item(waterfall_item_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_ITEM,
        method: HttpMethods.DELETE,
        query_parameters: { waterfall_item_id: waterfall_item_id },
    };
}
